import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {PracticeSettings} from './entities/practice-settings';
import {Observable} from 'rxjs';
import {PracticeSettingsItemResponse} from './entities/practice-settings-item-response';
import {ApiService} from '../base/repository/api.service';
import {AdminApiService} from '../base/repository/admin-api.service';
import {ItemUpdatedResponse} from '../base/entities/item-updated-response';

@Injectable({
  providedIn: 'root'
})
export class PracticeSettingsRepositoryService {

  constructor(private api: ApiService, private adminApi: AdminApiService) {
  }

  private mapTemplateIds(settings: PracticeSettings): PracticeSettings {
    // Map template objects to template IDs if not already set
    if (settings.chronicScriptTemplate && !settings.chronicScriptTemplateId) {
      settings.chronicScriptTemplateId = settings.chronicScriptTemplate.id;
    }
    if (settings.acuteScriptTemplate && !settings.acuteScriptTemplateId) {
      settings.acuteScriptTemplateId = settings.acuteScriptTemplate.id;
    }
    if (settings.historicalScriptTemplate && !settings.historicalScriptTemplateId) {
      settings.historicalScriptTemplateId = settings.historicalScriptTemplate.id;
    }
    if (settings.hemodialysisScriptTemplate && !settings.hemodialysisScriptTemplateId) {
      settings.hemodialysisScriptTemplateId = settings.hemodialysisScriptTemplate.id;
    }
    if (settings.treatmentPlanTemplate && !settings.treatmentPlanTemplateId) {
      settings.treatmentPlanTemplateId = settings.treatmentPlanTemplate.id;
    }
    if (settings.labelTemplate && !settings.labelTemplateId) {
      settings.labelTemplateId = settings.labelTemplate.id;
    }
    if (settings.erythropoietinScriptTemplate && !settings.erythropoietinScriptTemplateId) {
      settings.erythropoietinScriptTemplateId = settings.erythropoietinScriptTemplate.id;
    }
    return settings;
  }

  load(): Observable<PracticeSettings> {
    return this.api.get<PracticeSettingsItemResponse>('/practices/settings')
      .pipe(map(response => this.mapTemplateIds(response.value)));
  }

  adminLoad(): Observable<PracticeSettings> {
    return this.adminApi.get<PracticeSettingsItemResponse>('/practicesettings')
      .pipe(map(response => this.mapTemplateIds(response.value)));
  }

  adminUpdate(practiceSettings: PracticeSettings): Observable<boolean> {
    return this.adminApi.post<ItemUpdatedResponse>('/practicesettings', practiceSettings)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }
}
